import { store } from '@/store/store'
import BaseMixin from './base.mixin'

const mixin = {
  mixins: [BaseMixin],
  methods: {
    getCurrentUserSourcesWithFilters({ page = 1, pageSize = 50, name } = {}) {
      return new Promise(async (resolve) => {
        try {
          const params = { Page: page, PageSize: pageSize }
          if (name && String(name).trim()) params.Name = name.trim()

          const res = await this.getClient().get(`/core/ExamSource/ExamSource/CurrentUserSourcesWithFilters`, {
            params
          })
          if (res.status === 200 && res.data) {
            return resolve(res.data.data || [])
          }
          return resolve([])
        } catch (e) {
          return resolve([])
        }
      })
    },
    getExamSourceLogo() {
      return new Promise(async (resolve) => {
        if (!store.state.examSourceLogo) {
          const res = await this.getClient().get(
            `/core/ExamSource/ExamSource/Logo`,
            { responseType: 'blob', useSelectedSource: true },
            true
          )
          if (res.status === 200 && res.data) {
            const examSourceLogo = window.URL.createObjectURL(new Blob([res.data], { type: 'jpeg' }))
            store.dispatch('setExamSourceLogo', examSourceLogo)
            return resolve(examSourceLogo)
          }

          return resolve()
        }

        return resolve(store.state.examSourceLogo)
      })
    },
    getFinantialAlert() {
      return new Promise(async (resolve) => {
        const res = await this.getClient().get(`/core/ExamSource/FinantialAlert`, { useSelectedSource: true }, true)
        if (res.status === 200 && res.data) {
          return resolve(res.data)
        }

        return resolve()
      })
    },
    addSubscription(subscription) {
      return this.requestPost('/core/ExamSource/AddSubscription', subscription)
    }
  }
}

export default mixin
